import { getTransports } from './Transport'
import type { Transport } from './Transport'

/**
 * Method responsible for tracking an event for each existing transport
 *
 * @param event - The event name
 * @param context - The event context
 */
export const track = (...args: Parameters<Transport['track']>) => {
  getTransports().forEach((transport) => transport.track(...args))
}

/**
 * Method responsible for tracking a page view for each existing transport
 *
 * @param args - The page view context and extras
 */
export const pageView = (...args: Parameters<Transport['page']>) => {
  getTransports().forEach((transport) => transport.page(...args))
}

/**
 * Method responsible for identifying a user for each existing transport
 *
 * @param args - The user track
 */
export const identify = (...args: Parameters<Transport['identify']>) => {
  getTransports().forEach((transport) => transport.identify(...args))
}
